"use strict";var r=require("../Array/arrayFrom.cjs");exports.objectGroupBy=function(u,e){return r.arrayFrom(u).reduce((function(r,u,o){var t,a=e(u,o);return(null!==(t=r[a])&&void 0!==t?t:r[a]=[]).push(u),r}),{})};
//# sourceMappingURL=objectGroupBy.cjs.map
